import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, LogIn } from "lucide-react";
import { api, formatApiError } from "@/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("fl-token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-mare flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="w-full max-w-sm bg-white rounded-3xl p-8 shadow-2xl">
        <Link to="/" className="flex justify-center mb-8">
          <img src="/logo.png" alt="Like Follonica" className="h-20 w-auto" />
        </Link>
        <h1 className="font-heading font-bold text-xl text-center text-grafite mb-6">Back-office</h1>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <input
            data-testid="admin-email"
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="rounded-2xl border border-black/10 bg-calce px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-turchese"
          />
          <input
            data-testid="admin-password"
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="rounded-2xl border border-black/10 bg-calce px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-turchese"
          />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600 text-center">{error}</p>}
          <button type="submit" data-testid="admin-login-submit" disabled={loading}
            className="rounded-full bg-terracotta hover:bg-[#d15f2d] disabled:opacity-60 text-white font-bold py-3.5 inline-flex items-center justify-center gap-2 transition-colors">
            <LogIn className="w-4 h-4" /> {loading ? "…" : "Entra"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
